
import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace } from "vuex-class"

import { CaseDetails } from "@/types"
import { PortalTarget } from "portal-vue"

const caseStore = namespace("cases")

@Component({
	components: {
		"case-details": () => import("@/components/New/Cases/CaseDetails.vue"),
		"portal-target": PortalTarget
	}
})
export default class CasePopup extends Vue {
	@Prop({ default: null })
	value!: { templateId: string } | null

	@Prop({ default: null })
	caseNumber!: string | null

	caseDetails: CaseDetails | null = null

	get open (): boolean {
		return !!this.value || !!this.caseNumber
	}

	set open (value: boolean) {
		if (!value) {
			this.$emit("input", null)
			this.$emit("closed", this.caseDetails)
		}
	}

	get viewCaseNumber (): string {
		return this.caseNumber || "new"
	}

	private close () {
		this.$emit("input", null)
		this.$emit("closed", this.caseDetails)
	}

	private createdCase (created: CaseDetails) {
		this.$bvToast.toast(`Created #${created.caseNumber}`, {
			title: "Created",
			href: `/#/v2/cases/${encodeURIComponent(created.caseNumber as string)}`,
			variant: "success",
			solid: true,
			autoHideDelay: 5000
		})

		this.$emit("input", null)
		this.$emit("closed", this.caseDetails)
	}

	private caseLoaded (caseDetails: CaseDetails) {
		this.caseDetails = caseDetails
	}
}

